import axios from "axios";
import { getIds } from "@/lib/analytics";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Single integration point for campaign briefs — swap the endpoint for a CRM later.
export async function submitSilverCampaign(payload) {
  const { data } = await axios.post(`${API}/enquiries`, payload);
  return data;
}

export function buildCampaignPayload({ audience, filters, audienceLabel, campaign, price, customer }) {
  return {
    campaign: "Homeowner Audience",
    postcodeDistricts: audience.areas,
    audiencePreset: audienceLabel,
    filters: {
      retirement: filters.retirement,
      property: filters.property,
      downsize: filters.downsize,
      capitalRelease: filters.capitalRelease,
      sheltered: filters.sheltered,
      care: filters.care,
      opportunityMatch: filters.opportunityMatch,
    },
    matchingHouseholds: audience.total,
    selectedQuantity: price.quantity,
    pricePerAddress: price.pricePerAddress,
    estimatedPrice: price.baseCost,
    campaignAngle: campaign.angleLabel || null,
    creativeTheme: campaign.creativeLabel || null,
    format: campaign.formatLabel || null,
    services: campaign.serviceLabels,
    campaignMessage: campaign.message || null,
    customer,
    ...getIds(),
  };
}

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
